function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "get"); return _classApplyDescriptorGet(receiver, descriptor); }

function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = _classExtractFieldDescriptor(receiver, privateMap, "set"); _classApplyDescriptorSet(receiver, descriptor, value); return value; }

function _classExtractFieldDescriptor(receiver, privateMap, action) { if (!privateMap.has(receiver)) { throw new TypeError("attempted to " + action + " private field on non-instance"); } return privateMap.get(receiver); }

function _classApplyDescriptorSet(receiver, descriptor, value) { if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } }

var _options = /*#__PURE__*/new WeakMap();

var _timeline = /*#__PURE__*/new WeakMap();

var _toggleElement = /*#__PURE__*/new WeakMap();

var _setup = /*#__PURE__*/new WeakMap();

var _setupAnimationTimeline = /*#__PURE__*/new WeakMap();

var _addElementClasses = /*#__PURE__*/new WeakMap();

var _createToggle = /*#__PURE__*/new WeakMap();

/* eslint-disable max-classes-per-file */
var AccordionRow = /*#__PURE__*/function () {
  function AccordionRow(element, options, gsap) {
    var _this = this;

    _classCallCheck(this, AccordionRow);

    _defineProperty(this, "open", false);

    _defineProperty(this, "gsap", undefined);

    _options.set(this, {
      writable: true,
      value: {
        parentNodeClassName: "accordion--row",
        elementClassName: "accordion--content",
        toggleBtnClass: "accordion--toggle",
        toggleHTML: '<i class="fas fa-caret-down"></i>',
        duration: 0.3
      }
    });

    _timeline.set(this, {
      writable: true,
      value: void 0
    });

    _toggleElement.set(this, {
      writable: true,
      value: void 0
    });

    _setup.set(this, {
      writable: true,
      value: function value() {
        _classPrivateFieldGet(_this, _addElementClasses).call(_this);

        _classPrivateFieldGet(_this, _createToggle).call(_this);

        _classPrivateFieldGet(_this, _setupAnimationTimeline).call(_this);
      }
    });

    _setupAnimationTimeline.set(this, {
      writable: true,
      value: function value() {
        _this.gsap.set(_this.element, {
          height: 0
        }); // Animate row open


        _this.timeline.to(_this.element, {
          height: "auto",
          duration: _classPrivateFieldGet(_this, _options).duration
        });

        _this.timeline.fromTo(_classPrivateFieldGet(_this, _toggleElement), {
          rotate: 0
        }, {
          rotate: -180
        }, 0);
      }
    });

    _addElementClasses.set(this, {
      writable: true,
      value: function value() {
        _this.element.classList.add(_classPrivateFieldGet(_this, _options).elementClassName);

        _this.element.parentNode.classList.add(_classPrivateFieldGet(_this, _options).parentNodeClassName);
      }
    });

    _createToggle.set(this, {
      writable: true,
      value: function value() {
        _classPrivateFieldSet(_this, _toggleElement, document.createElement("button"));

        _classPrivateFieldGet(_this, _toggleElement).className = _classPrivateFieldGet(_this, _options).toggleBtnClass;
        _classPrivateFieldGet(_this, _toggleElement).innerHTML = _classPrivateFieldGet(_this, _options).toggleHTML;

        _classPrivateFieldGet(_this, _toggleElement).setAttribute("aria-label", "Expand Menu");

        _classPrivateFieldGet(_this, _toggleElement).addEventListener("click", _this.toggleRow);

        _this.element.parentNode.appendChild(_classPrivateFieldGet(_this, _toggleElement));
      }
    });

    _defineProperty(this, "expandRow", function () {
      _this.timeline.play().then(function () {
        _this.open = true;
      });
    });

    _defineProperty(this, "closeRow", function () {
      _this.timeline.reverse().then(function () {
        _this.open = false;
      });
    });

    _defineProperty(this, "toggleRow", function () {
      if (_this.open) {
        _this.closeRow();
      } else {
        _this.expandRow();
      }
    });

    this.element = element;
    this.gsap = gsap;

    if (!this.element) {
      throw new Error("[Accordion Row] Element not found");
    } // Merge user options with defaults


    _classPrivateFieldSet(this, _options, _objectSpread(_objectSpread({}, _classPrivateFieldGet(this, _options)), options));

    _classPrivateFieldGet(this, _setup).call(this);
  }

  _createClass(AccordionRow, [{
    key: "timeline",
    get: function get() {
      // Caching
      if (!_classPrivateFieldGet(this, _timeline)) {
        _classPrivateFieldSet(this, _timeline, this.gsap.timeline({
          paused: true
        }));
      }

      return _classPrivateFieldGet(this, _timeline);
    }
  }]);

  return AccordionRow;
}();

var _options2 = /*#__PURE__*/new WeakMap();

var _setupRows = /*#__PURE__*/new WeakMap();

var Accordion = function Accordion(options) {
  var _this2 = this;

  _classCallCheck(this, Accordion);

  _options2.set(this, {
    writable: true,
    value: {
      selector: ".accordion .content"
    }
  });

  _defineProperty(this, "rows", []);

  _defineProperty(this, "gsap", undefined);

  _setupRows.set(this, {
    writable: true,
    value: function value() {
      // borrow the map method from array to use on the nodelist
      _this2.rows = [].slice.call(document.querySelectorAll(_classPrivateFieldGet(_this2, _options2).selector)).map(function (element) {
        return new AccordionRow(element, _classPrivateFieldGet(_this2, _options2), _this2.gsap);
      });
    }
  });

  // Merge user options with defaults
  _classPrivateFieldSet(this, _options2, _objectSpread(_objectSpread({}, _classPrivateFieldGet(this, _options2)), options));

  import('gsap').then(function (_ref) {
    var gsap = _ref.gsap;
    _this2.gsap = gsap;
  }).then(function () {
    _classPrivateFieldGet(_this2, _setupRows).call(_this2);
  });
};

export { Accordion as default };